import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import type { FC } from 'react';

interface Props {
  onClick?: () => void;
  size?: number | string;
}
export const BackButton: FC<Props> = ({ onClick, size }) => (
  <Button
    data-testid="previous-action"
    type="text"
    icon={<ArrowLeftOutlined />}
    onClick={onClick}
    style={{ fontSize: '18px', width: size, height: size }}
  />
);
